<ng-container *transloco="let t">
  <div class="session-timeout-overlay" role="dialog" aria-modal="true" [attr.aria-label]="t('session.warningTitle')">
    <div class="session-timeout-panel">
      <h2 class="session-timeout-panel__title">{{ t('session.warningTitle') }}</h2>
      <p class="session-timeout-panel__body">{{ t('session.warningBody') }}</p>
      <div class="d-flex gap-2 justify-content-end mt-3">
        <button
          type="button"
          class="btn btn-secondary"
          data-testid="sign-out-button"
          (click)="onSignOut()">
          {{ t('common.signOut') }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          data-testid="stay-signed-in-button"
          (click)="onStaySignedIn()">
          {{ t('session.staySignedIn') }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
